var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alive)?_c('a-layout',{class:_vm.$style.root,on:{"click":_vm.isTimeOut}},[_c('div',{staticClass:"main"},[(_vm.hackReset)?_c('a-layout-header',[_c('Header')],1):_vm._e(),_c('a-layout-content',[_c('router-view')],1)],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }